<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div class="d-flex flex-column gap-8 w-100">
  <div id="header-container" class="pb-2">
    <h3 id="header-text">Global Scenario Associations</h3>
    <button mat-flat-button color="primary" id="run-report-button" class="action-button"
            (click)="getGlobalScenarioAssociations()"
            [disabled]="!globalScenario">
      Run Report
    </button>
  </div>
  <div class="d-flex content-height w-100">
    <app-global-scenario-select-component
      class="w-100"
      [memberScenarioType]="0"
      [filterNonGM]="false"
      [user]="stateService.getUserGmid()"
      [displayedMemberColumns]="columnHeaders"
      (confirmEvent)="onSelect($event)">
    </app-global-scenario-select-component>
  </div>
</div>
